import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = { 
  currentToken: JSON.parse(Cookies.get("token") || null),
  userProfile: null,
  isUserProfileLoaded: false
};

const authReducer = createSlice({
  name: "token",
  initialState,
  reducers: {
    login(state, action) {
      state.currentToken = action.payload;
    },
    setUserProfile(state, action) {
      state.userProfile = action.payload;
      state.isUserProfileLoaded = true;
    },
    clearUserProfile(state) {
      state.userProfile = null;
      state.isUserProfileLoaded = false;
    },
  },
});

export const { login, setUserProfile, clearUserProfile } = authReducer.actions;
export default authReducer.reducer;
